/**
 * Sample data generator utility
 * This will populate the localStorage with initial data for new users
 */

// Generate dates within a range
const randomDate = (start, end) => {
  const startDate = start || new Date(new Date().setDate(new Date().getDate() - 30));
  const endDate = end || new Date();
  return new Date(startDate.getTime() + Math.random() * (endDate.getTime() - startDate.getTime())).toISOString().split('T')[0];
};

// Generate random amount
const randomAmount = (min, max) => Math.floor(Math.random() * (max - min + 1)) + min;

// Document statuses with weighted probability
const documentStatuses = ['paid', 'paid', 'paid', 'pending', 'pending', 'overdue'];

// Initialize with real sample data
export const initializeSampleData = () => {
  // Check if already initialized
  const initialized = localStorage.getItem('facit_initialized');
  if (initialized === 'true') {
    return;
  }
  
  // Sample products data
  const products = [
    { 
      id: 1, 
      name: 'Développement Site Web', 
      description: 'Création de site web responsive avec CMS',
      type: 'service',
      category: 'Services Informatiques',
      price: 250000,
      unit: 'forfait',
      sku: 'SRV-001',
      stock: null,
      status: 'active'
    },
    { 
      id: 2, 
      name: 'Ordinateur Portable Dell', 
      description: 'Dell Latitude 7420, i7, 16GB RAM, 512GB SSD',
      type: 'product',
      category: 'Matériel Informatique',
      price: 185000,
      unit: 'unité',
      sku: 'MAT-002',
      stock: 4, // Low stock to trigger notification
      status: 'active'
    },
    { 
      id: 3, 
      name: 'Formation React.js', 
      description: 'Formation complète React.js - 40 heures',
      type: 'service',
      category: 'Formation',
      price: 75000,
      unit: 'session',
      sku: 'FOR-003',
      stock: null,
      status: 'active'
    },
    { 
      id: 4, 
      name: 'Serveur HP ProLiant', 
      description: 'Serveur HP ProLiant DL380 Gen10',
      type: 'product',
      category: 'Matériel Informatique',
      price: 450000,
      unit: 'unité',
      sku: 'MAT-004',
      stock: 3,
      status: 'active'
    },
    { 
      id: 5, 
      name: 'Audit Sécurité IT', 
      description: 'Audit complet de sécurité informatique',
      type: 'service',
      category: 'Consulting',
      price: 120000,
      unit: 'jour',
      sku: 'CON-005',
      stock: null,
      status: 'active'
    },
    { 
      id: 6, 
      name: 'Écran 27" 4K', 
      description: 'Écran Dell UltraSharp 27"',
      type: 'product',
      category: 'Matériel Informatique',
      price: 65000,
      unit: 'unité',
      sku: 'MAT-006',
      stock: 12,
      status: 'active'
    }
  ];
  
  // Sample clients data
  const clients = [
    {
      id: 1,
      clientNumber: '01',
      type: 'company',
      name: 'SARL TechnoAlger',
      contactPerson: 'Ahmed Belkacem',
      email: 'contact@technoalger.dz',
      phone: '+213 21 456 789',
      address: '15 Rue Didouche Mourad, Alger',
      city: 'Alger',
      postalCode: '16000',
      registrationNumber: 'RC 16/001234',
      taxNumber: 'NIF 098765432109',
      fiscalId: '163190104418159',
      article: '1901022407',
      rc: '19/00-0433048A99',
      contactPhone: '036 62 60 08',
      category: 'Technologie',
      status: 'active',
      createdDate: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 3))),
      lastOrder: randomDate(),
      totalOrders: 12,
      totalAmount: 2850000
    },
    {
      id: 2,
      clientNumber: '02',
      type: 'individual',
      name: 'Dr. Fatima Benali',
      contactPerson: 'Dr. Fatima Benali',
      email: 'f.benali@clinique.dz',
      phone: '+213 31 234 567',
      address: '45 Boulevard 1er Novembre, Oran',
      city: 'Oran',
      postalCode: '31000',
      registrationNumber: '',
      taxNumber: '',
      fiscalId: '163190105522840',
      article: '1901032815',
      rc: '31/00-1234567B88',
      contactPhone: '+213 31 234 567',
      category: 'Santé',
      status: 'active',
      createdDate: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 2))),
      lastOrder: randomDate(),
      totalOrders: 5,
      totalAmount: 675000
    },
    {
      id: 3,
      clientNumber: '03',
      type: 'company',
      name: 'EURL InnovCorp',
      contactPerson: 'Karim Messaoudi',
      email: 'info@innovcorp.dz',
      phone: '+213 25 345 678',
      address: '78 Rue Ben Badis, Constantine',
      city: 'Constantine',
      postalCode: '25000',
      registrationNumber: 'RC 25/005678',
      taxNumber: 'NIF 123456789012',
      fiscalId: '163190106633951',
      article: '2501041203',
      rc: '25/00-7890123C77',
      contactPhone: '+213 25 345 678',
      category: 'Innovation',
      status: 'active',
      createdDate: randomDate(new Date(new Date().setMonth(new Date().getMonth() - 1))),
      lastOrder: randomDate(),
      totalOrders: 8,
      totalAmount: 1450000
    }
  ];
  
  // Generate more realistic documents for charts
  const generateRealisticDocuments = () => {
    const documents = [];
    const categories = ['FACTURATION', 'OFFRES COMMERCIALES', 'LOGISTIQUE'];
    const types = ['invoice', 'quote', 'proforma', 'delivery', 'purchase_order'];
    const titles = {
      invoice: ['Facture Développement Web', 'Facture Matériel IT', 'Facture Formation', 'Facture Services Cloud'],
      quote: ['Devis Système de Gestion', 'Devis Infrastructure IT', 'Devis Services Cloud'],
      proforma: ['Facture Proforma Formation', 'Facture Proforma Matériel IT'],
      delivery: ['Bon de Livraison Matériel', 'Bon de Livraison Équipements'],
      purchase_order: ['Bon de Commande Serveurs', 'Bon de Commande Formation', 'Bon de Commande Licences']
    };
    
    // Generate documents for past 6 months
    const startDate = new Date();
    startDate.setMonth(startDate.getMonth() - 6);
    
    // Generate 5 documents with realistic dates and amounts (reduced from 50)
    for (let i = 1; i <= 5; i++) {
      const type = types[Math.floor(Math.random() * types.length)];
      const category = categories[Math.floor(Math.random() * categories.length)];
      const clientId = Math.floor(Math.random() * clients.length) + 1;
      const client = clients.find(c => c.id === clientId);
      const date = randomDate(startDate);
      const title = titles[type][Math.floor(Math.random() * titles[type].length)];
      const status = documentStatuses[Math.floor(Math.random() * documentStatuses.length)];
      
      // Generate items using product data
      const itemCount = Math.floor(Math.random() * 3) + 1;
      const items = [];
      let totalAmount = 0;
      
      for (let j = 0; j < itemCount; j++) {
        const product = products[Math.floor(Math.random() * products.length)];
        const quantity = Math.floor(Math.random() * 5) + 1;
        const item = {
          id: j + 1,
          name: product.name,
          quantity,
          price: product.price
        };
        items.push(item);
        totalAmount += item.price * item.quantity;
      }
      
      // Create document
      documents.push({
        id: i,
        type,
        number: `${type === 'invoice' ? 'FAC' : type === 'quote' ? 'DEV' : type === 'proforma' ? 'PRO' : type === 'delivery' ? 'BL' : 'BC'}-${1000 + i}`,
        title,
        client: client.name,
        date,
        dueDate: type === 'invoice' ? new Date(new Date(date).setDate(new Date(date).getDate() + 30)).toISOString().split('T')[0] : undefined,
        validUntil: type === 'quote' ? new Date(new Date(date).setDate(new Date(date).getDate() + 30)).toISOString().split('T')[0] : undefined,
        amount: totalAmount,
        status,
        category,
        items
      });
    }
    
    return documents;
  };
  
  // Save sample data to localStorage
  localStorage.setItem('facit_products', JSON.stringify(products));
  localStorage.setItem('facit_clients', JSON.stringify(clients));
  localStorage.setItem('facit_documents', JSON.stringify(generateRealisticDocuments()));
  
  // Mark as initialized
  localStorage.setItem('facit_initialized', 'true');
  
  console.log('Sample data initialized');
  
  // Return generated data
  return {
    products,
    clients,
    documents: generateRealisticDocuments()
  };
}; 